// Per-site subscription entitlement, mirrored from backend common.site_entitled.
// Full access while the 30-day trial is live, a subscription is active, OR the
// site is inside the 3-day grace window after a failed renewal (past_due).
// Annual plan headline saving vs paying monthly (29*12 - 330.60 = $17.40/yr).
export const ANNUAL_SAVING = 17;

export function computeEntitlement(site) {
  if (!site) {
    return { entitled: true, status: "trialing", daysLeft: 0, expired: false, trialing: false, pastDue: false };
  }
  const status = site.subscription_status || "trialing";
  const now = Date.now();

  if (status === "active") {
    return { entitled: true, status, daysLeft: 0, expired: false, trialing: false, pastDue: false };
  }

  if (status === "past_due") {
    const gu = site.grace_until ? new Date(site.grace_until).getTime() : 0;
    const inGrace = gu > now;
    const daysLeft = gu ? Math.max(0, Math.ceil((gu - now) / 86400000)) : 0;
    return { entitled: inGrace, status, daysLeft, expired: !inGrace, trialing: false, pastDue: true };
  }

  const te = site.trial_ends_at ? new Date(site.trial_ends_at).getTime() : 0;
  const trialing = te > now;
  const daysLeft = te ? Math.max(0, Math.ceil((te - now) / 86400000)) : 0;
  return { entitled: trialing, status, daysLeft, expired: !trialing, trialing, pastDue: false };
}
